export const selectsInState = ['paymentMethod'];

export const initialState = {
  paymentMethod: {
    value: '',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Selecciona el medio de pago con el que realizaste tu compra:',
    required: true,
    success: false,
  },
};

export const makeInitialState = (paymentValue) => {
  return {
    paymentMethod: {
      value: paymentValue !== '' ? paymentValue : '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Selecciona el medio de pago con el que realizaste tu compra:',
      required: true,
      success: paymentValue !== '' ? true : false,
    },
  };
};

export const initialStateDebit = {
  paymentMethod: {
    value: 'Tarjeta de débito',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Selecciona el medio de pago con el que realizaste tu compra:',
    required: true,
    success: true,
  },
  bankOption: {
    value: '',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Banco',
    required: true,
    success: false,
  },
  accountNumber: {
    value: '',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Nº de cuenta',
    required: true,
    success: false,
  },
  accountAddress: {
    value: '',
    error: false,
    message: '',
    helper: '',
    inputAdornment: '',
    label: 'Dirección',
    required: true,
    success: false,
  },
};
